export const BEBaseRoot = process.env.REACT_APP_BE_BASE_ROOT || "http://localhost:8000/";
export const BEBase = `${BEBaseRoot}api`;

export const PaymentStatus = {
    SUCCESS: "Success",
    FAILURE: "Failure",
    PENDING: "Pending"
};

// Firebase configuration
export const FirebaseConfig = {
    apiKey: "AIzaSyDXP-IRnERY_-Wa0HR4zip1f9iLu1gnhmk",
    authDomain: "xdixtute.firebaseapp.com",
    projectId: "xdixtute",
    storageBucket: "xdixtute.firebasestorage.app",
    messagingSenderId: "843377212100",
    appId: "1:843377212100:web:399ab66c6f24ac7109a791",
    measurementId: "G-T9WE721R6W"
};

// Firebase Cloud Messaging VAPID key for web push notifications
export const FirebaseVapidKey = "BIIEuqDf7kDYq9sPJfGb8S-59r-AFPo0uefUCEnRIbyf6TVzbdTuCOuQLoU8s_JqB5iH016WqUsTCm4ZDIm9y3s";

export const ALL_ROLES = ["client", "admin", "investor"];

export const LEAD_ROLES = ["admin", "investor"]
